import { AbstractControl, ValidatorFn } from '@angular/forms';

export function requiredTrueValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value !== true) {
      return { requiredTrue: true };
    }
    return null;
  };
}
